
/**
 * This is not an enum by type but by function (because we need strings as readonly constants)
 * This class holds eventsnames for awallComponenentEvents.
 */

export class ComponentEvent {
  public static readonly INFOVIEW_INSERT_WRAPPER = 'infoview-insert-wrapper';
  public static readonly INFOVIEW_REMOVE_WRAPPER = 'infoview-remove-wrapper';
  public static readonly INFOVIEW_UPDATE_SPACERS = 'infoview-udpate-spacers';
  //
  public static readonly TOOLBAR_ACTIVATE_WIDGET = 'toolbar-activate-widget';
  public static readonly TOOLBAR_DEACTIVATE_WIDGET = 'toolbar-deactivate-widget';
  public static readonly TOOLBAR_INSERT_WRAPPER = 'toolbar-insert-wrapper';
  public static readonly TOOLBAR_REMOVE_WRAPPER = 'toolbar-remove-wrapper';
  public static readonly TOOLBAR_CLOSE_WRAPPER = 'toolbar-close-wrapper';
  //
  public static readonly WIDGET_VTR_VIDEO_ACTIVE = 'vtr-video-active';
  //
  public static readonly MPCBOARD_REMOVE_TEAM = 'mpcboard-remove-team';
  public static readonly MPCBOARD_CHANGED = 'mpcboard-changed';
  public static readonly MPCBOARD_SPRINT_ADD_ISSUE = 'mpcboardsprint-add-issue';
  public static readonly MPCBOARD_SPRINT_REMOVE_ISSUE = 'mpcboardsprint-remove-issue';
  public static readonly MPCBOARD_FILTER_ISSUES = 'mpcboardsprint-filter-issues';
  //
  public static readonly BOARD_CHANGED = 'board-changed';
  //
  public static readonly BACKLOG_REQUEST_UPDATE = 'backlog-request-update';
  //
  public static readonly DEPENDENCY_EDITMODE_CHANGED = 'dependencies-editmode-changed';
  public static readonly DEPENDENCY_VISIBILITY_CHANGED = 'dependency-visibility-changed';
  //
  public static readonly ISSUE_TEAMMEMBER_DROPPED = 'issue-teammember-dropped';
  //
  public static readonly WIDGET_TEAM_HIGHLIGHT_CHANGED = 'widget-team-highlight-changed';
}
